/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createRefreshUrlResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type RefreshUrlResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/companydocs/documents/{documentId}/refresh-url
 */
export interface RefreshUrlRequestBuilder extends BaseRequestBuilder<RefreshUrlRequestBuilder> {
    /**
     * Issues a new time-limited link to a document and stores it, so later reads of the same document return the new link too. The new link lasts as long as the one issued at upload. Send no body — the document is identified by the route id alone. Call this when a cdnUrl from an earlier response has stopped working; links expire by design, so an expired one is expected rather than a fault. Sales reps may call this as well as administrators, which is what lets the sales app renew a link it cached. An unknown document id is reported as a bad request, not as a 404.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<RefreshUrlResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<RefreshUrlResponse | undefined>;
    /**
     * Issues a new time-limited link to a document and stores it, so later reads of the same document return the new link too. The new link lasts as long as the one issued at upload. Send no body — the document is identified by the route id alone. Call this when a cdnUrl from an earlier response has stopped working; links expire by design, so an expired one is expected rather than a fault. Sales reps may call this as well as administrators, which is what lets the sales app renew a link it cached. An unknown document id is reported as a bad request, not as a 404.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const RefreshUrlRequestBuilderUriTemplate = "{+baseurl}/api/companydocs/documents/{documentId}/refresh-url";
/**
 * Metadata for all the requests in the request builder.
 */
export const RefreshUrlRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: RefreshUrlRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createRefreshUrlResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
